"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormArchiveConfirmModal = void 0;
const tslib_1 = require("tslib");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
class FormArchiveConfirmModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, formSummary) {
        super(ctx);
        this.formSummary = formSummary;
    }
    get nodes() {
        return (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.FORM_ARCHIVE_CONFIRM, { name: this.formSummary.displayname }));
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield services_1.Services.Form.archive(this.formSummary.uuid);
        });
    }
}
exports.FormArchiveConfirmModal = FormArchiveConfirmModal;
//# sourceMappingURL=form.archive.confirm.modal.js.map